import React from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import editLineLength from '../../../assets/img/help/edit-line-length.png';
import { svgEl } from '../../App/DrawArea/DrawArea';
import { helpActivateEditLineLength } from '../../../shared/actions/helpActions';

export let renderEditLineLength;

class EditLineLength extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			bounds: null
		};
	}

	componentWillMount() {
		renderEditLineLength = this.forceRender.bind(this);
	}

	componentWillUnmount() {
		renderEditLineLength = null;
	}

	forceRender(bounds) {
		this.setState({ bounds });
	}

	render() {
		if (!this.state.bounds || !svgEl) {
			return null;
		}

		const svgBounds = svgEl.getBoundingClientRect(),
			style = {
				left: this.state.bounds.left + this.state.bounds.width / 2 - 275 / 2
			};

		let arrow = 'arrow-bottom';

		if (this.state.bounds.top - svgBounds.top < 230) {
			style.top = this.state.bounds.top + this.state.bounds.height - svgBounds.top + 15;
			arrow = 'arrow-top';
		} else {
			style.top = this.state.bounds.top - svgBounds.top - 230;
		}

		return (
			<div style={style} className={`contextual-modal ${arrow}`}>
				<h3 className='title'>Adjust Length</h3>
				<div className='content'>
					Select a length label to edit.
					<img src={editLineLength} className='edit-line-length' alt='Edit Line Length' />
				</div>
				<div className='actions'>
					<button
						onClick={() => {
							this.props.helpActivateEditLineLength();
						}}
						className='btn btn-sm btn-modal'>
						ok
					</button>
				</div>
			</div>
		);
	}
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators(
		{
			helpActivateEditLineLength
		},
		dispatch
	);
}

export default connect(null, mapDispatchToProps)(EditLineLength);
